module.exports = __webpack_public_path__ + "static/media/priorly-clock.eebaddb9.svg";